import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { LineReveal } from "../components/Reveal";

const suggestions = [
  { to: "/", label: "Back to the beginning" },
  { to: "/stories", label: "Read a story" },
  { to: "/events", label: "Find an event" },
  { to: "/get-involved", label: "Get involved" },
];

export default function NotFound() {
  return (
    <main className="min-h-[80vh] flex items-center" data-testid="not-found">
      <SEO title="Page not found" description="This page wandered off — but kindness rarely does. Find your way back." path="/404" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-32">
        <p className="text-xs uppercase tracking-[0.25em] font-medium text-ink-2">404</p>
        <h1 className="mt-6 font-serif tracking-tighter leading-[0.98] text-ink text-5xl sm:text-6xl lg:text-7xl max-w-3xl">
          <LineReveal lines={["This page wandered off.", "Kindness rarely does."]} delay={0.15} />
        </h1>
        <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-ink-2">
          The link may be old, or the page may have moved. Here are a few good
          places to land instead.
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl">
          {suggestions.map((s) => (
            <Link
              key={s.to}
              to={s.to}
              data-testid={`notfound-link-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex items-center justify-between gap-4 border border-line rounded-xl px-6 py-5 bg-sand transition-colors hover:bg-sand-2"
            >
              <span className="font-serif text-xl tracking-tight text-ink">{s.label}</span>
              <ArrowRight className="h-4 w-4 text-action transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
